import { useNavigate } from "react-router-dom";
import { httpFetchFlaggedTransactions } from "api/admin/transaction";
import AdminSidebar from "components/layout/AdminSidebar";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import Filter from "components/ui/Filter";
import Pagination from "components/ui/Pagination";
import Spinner from "components/ui/Spinner";
import Table from "components/ui/Table";
import { DateTime } from "luxon";
import { useState } from "react";
import { useQuery } from "react-query";
import { moneyFormat } from "utilities/currency";

const limit = 50;

const moduleStatuses = [
  { label: "Open", value: "open" },
  { label: "Resolved", value: "resolved" },
  { label: "All", value: "all" },
];

type ModuleStatus = "open" | "resolved" | "all";

const isModuleStatus = (value: string): value is ModuleStatus =>
  moduleStatuses.some((status) => status.value === value);

const formatAmount = (row: any) => {
  return `${moneyFormat(row.amount)} ${row.currency || "(currency unavailable)"}`;
};

const FlaggedTransactions: React.FC = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [moduleStatus, setModuleStatus] = useState<ModuleStatus>("open");

  const { data, isLoading } = useQuery(
    ["flaggedTransactions", currentPage, moduleStatus],
    () => httpFetchFlaggedTransactions(currentPage, limit, moduleStatus),
    {
      initialData: {
        rows: [],
        total: 0,
        page: 1,
      },
    },
  );

  const rows = data?.rows || [];

  return (
    <Container>
      <AdminSidebar />
      <Main className="mx-5 mt-5 text-left">
        <h3 className="mb-8 text-2xl">Flagged Transactions</h3>

        <div className="mb-8">
          <div className="mb-2 text-sm">Status:</div>
          <Filter
            data={moduleStatuses}
            setValue={(value: string) => {
              if (isModuleStatus(value)) {
                setModuleStatus(value);
              }
              setCurrentPage(1);
            }}
            value={moduleStatus}
          />
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center w-full h-64">
            <Spinner className="text-5xl" />
          </div>
        ) : rows.length ? (
          <>
            <Table
              header={["User", "Type", "Amount", "Reason", "Status", "Date"]}
              data={rows.map((row: any) => [
                row.userName ? `@${row.userName}` : `User ${row.userID}`,
                row.transactionType || "-",
                formatAmount(row),
                row.flagReason || "-",
                row.moduleStatus || "-",
                row.flagTimestamp
                  ? `${DateTime.fromISO(row.flagTimestamp).toFormat(
                      "DD",
                    )} ${DateTime.fromISO(row.flagTimestamp).toFormat("t")}`
                  : "-",
                () => navigate(`/withdrawal-reviews?review=${row.reviewID}`),
              ])}
            />
            <Pagination
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              limit={limit}
              page={data?.page || 1}
              total={data?.total || 0}
            />
          </>
        ) : (
          <div className="py-10 text-center text-gray-500">
            No flagged transactions found
          </div>
        )}
      </Main>
    </Container>
  );
};

export default FlaggedTransactions;
